import { maskitoTransform } from '@maskito/core';
import { maskitoNumberOptionsGenerator, maskitoParseNumber } from '@maskito/kit';
const DECIMAL_MASK = maskitoNumberOptionsGenerator({
    decimalZeroPadding: true,
    precision: 2,
    thousandSeparator: ',',
});
const WHOLE_NUMBER_MASK = maskitoNumberOptionsGenerator({
    min: 0,
    thousandSeparator: ',',
});
const NUMERIC_ONLY_MASK = {
    mask: /^\d*$/,
};
const EIN_MASK = {
    mask: [...new Array(2).fill(/\d/), '-', ...new Array(7).fill(/\d/)],
};
const VERIFICATION_CODE_MASK = {
    mask: [...new Array(6).fill(/\d/)],
};
const coerceValue = (value) => (typeof value === 'number' ? value.toString() : value);
const maskDecimal = (value) => value === 0 || value ? maskitoTransform(coerceValue(value), DECIMAL_MASK) : '';
const maskWholeNumber = (value) => value === 0 || value ? maskitoTransform(coerceValue(value), WHOLE_NUMBER_MASK) : '';
const maskDecimalWithoutTrailingZeros = (value) => maskDecimal(value).replace(/\.00$/, '');
const maskCompactNumber = (value, maximumFractionDigits = 1) => value === 0 || value
    ? Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits }).format(Number(value))
    : '';
const compactDollars = (value, fractionDigits = 2) => value.toLocaleString('en-US', {
    minimumFractionDigits: Number.isInteger(value) ? 0 : fractionDigits,
    maximumFractionDigits: fractionDigits,
});
const maskCompactCurrency = (value) => {
    const amount = Number(value ?? 0);
    const sign = amount < 0 ? '-' : '';
    const abs = Math.abs(amount);
    if (abs >= 1_000_000) {
        return `${sign}$${compactDollars(abs / 1_000_000, 1)}M`;
    }
    if (abs >= 1_000) {
        return `${sign}$${compactDollars(abs / 1_000, 1)}k`;
    }
    return `${sign}$${compactDollars(abs)}`;
};
const maskPercent = (value, fractionDigits = 1) => `${(value * 100).toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
})}%`;
const unmaskNumber = (value) => maskitoParseNumber(coerceValue(value ?? ''), '.');
export { DECIMAL_MASK, WHOLE_NUMBER_MASK, NUMERIC_ONLY_MASK, EIN_MASK, VERIFICATION_CODE_MASK, 
//
compactDollars, maskDecimal, maskDecimalWithoutTrailingZeros, maskWholeNumber, maskCompactNumber, maskCompactCurrency, maskPercent, unmaskNumber, };
